export const SHARE_ICON = "/images/shareIcon.svg";
export const COMPLETED_ICON = "/images/completed.png";
export const CLOSE_ICON = "/images/close.png";
